import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";

class MemberReports extends Component {
    body() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h2>Member Reports</h2>
                    </div>
                </div>

                <div className='row mt-3'>
                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/members/credit'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>Member Credit</h3>
                                <p className='card-text'>
                                    View available member credit arranged by
                                    active membership status.
                                </p>
                            </div>
                        </Link>
                    </div>

                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/members/tee-time-request-engagement'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>
                                    Tee-Time Request Engagement
                                </h3>
                                <p className='card-text'>
                                    View the percentage of each membership
                                    category that has made a tee-time request.
                                </p>
                            </div>
                        </Link>
                    </div>

                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/members/tee-time-payment-method-mix'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>
                                    Tee-Time Payment Method Mix
                                </h3>
                                <p className='card-text'>
                                    View the all-time split of tee-time
                                    requests by Green Fee, GFC, and Voucher.
                                </p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

export default MemberReports;
